import {
  Field,
  MessageBar,
  MessageBarBody,
  Select,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { GridLayout, MainGrid } from '@powerportalspro/react-fluent';
import { useMemo, useState } from 'react';
import {
  ALL_CONTACTS_VIEW_ID,
  MY_CONTACTS_VIEW_ID,
  getAllContactsView,
  getMyContactsView,
  useCurrentContactId,
} from './AccountAndContactCustomViews';

// The contacts as cards, each with its photo beside its name, and how narrow a card may
// be to play with. The toolbar's dropdown switches between cards, table rows and the
// automatic layout, which shows cards only on a phone.

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.CardLayout.CardLayoutMainDemo';

// Any CSS length works; these show the cards reflowing across a few.
const MIN_CARD_WIDTHS = ['200px', '260px', '320px', '400px', '50%'];

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalMNudge,
  },
});

export function CardLayoutMainSample() {
  const styles = useStyles();
  const t = useT();
  // A contact's id, for views over contacts: an internal user has none, and sees no "my contacts".
  const currentContactId = useCurrentContactId();
  const [minCardWidth, setMinCardWidth] = useState('320px');

  const customViews = useMemo(
    () => [getAllContactsView(), getMyContactsView(currentContactId)],
    [currentContactId],
  );

  return (
    <div className={styles.root}>
      <MessageBar intent="warning" layout="multiline">
        <MessageBarBody>{t(`${STRINGS_BASE}.login-required`)}</MessageBarBody>
      </MessageBar>

      <Field label={t(`${STRINGS_BASE}.min-card-width`)} orientation="horizontal">
        <Select value={minCardWidth} onChange={(_, data) => setMinCardWidth(data.value)}>
          {MIN_CARD_WIDTHS.map((width) => (
            <option key={width} value={width}>
              {width}
            </option>
          ))}
        </Select>
      </Field>

      <MainGrid
        tableName="contact"
        defaultLayout={GridLayout.Cards}
        allowChangingLayout
        cardImageColumn="entityimage"
        minCardWidth={minCardWidth}
        minHeight="600px"
        maxHeight="600px"
        pageSize={20}
        viewIds={[ALL_CONTACTS_VIEW_ID, MY_CONTACTS_VIEW_ID]}
        customViewDefinitions={customViews}
        defaultViewId={ALL_CONTACTS_VIEW_ID}
      />
    </div>
  );
}
